import { MediaFactory } from '../commons/medias/media.factory';
import { FactFactory } from './facts/fact-factory';
import { LinksFactory } from './links/links-factory';
import { LocationFactory } from './locations/location-factory';
import { ProfilePreferencesFactory } from './profile-preferences/profile-preferences-factory';
import { RoleSummaryFactory } from './roles/role-summary-factory';
import { SalaryFactory } from './salary/salary.factory';
import { SoftSkillFactory } from './soft-skills/soft-skill-factory';
import { TagSummaryFactory } from './tags';
import { ManfrediteTechnologyFactory } from './techs/manfredite-technology.factory';
import { TechSummaryFactory } from './techs/tech-summary-factory';
import { WorkplacePreferencesFactory } from './workplace-preferences/workplace-preferences-factory';
import { YearsOfExperienceFactory } from './years-of-experience/years-of-experience-factory';
export class ManfrediteResponseFactory {
    static create(props = {}) {
        const defaultProps = {
            profileId: 1,
            manfrediteId: 2,
            email: 'foo@bar.com',
            firstName: 'John',
            lastName: 'Doe',
            whereDoYouLive: LocationFactory.create(),
            telephone: '123456789',
            headline: 'Headline',
            introduction: 'Introduction',
            softSkills: SoftSkillFactory.createList(2),
            goodPractices: 'Good practices',
            facts: FactFactory.createList(3),
            links: LinksFactory.create(),
            yearsOfExperience: YearsOfExperienceFactory.create(),
            desiredRoles: RoleSummaryFactory.createList(3),
            techs: ManfrediteTechnologyFactory.createList(5),
            likedTechs: TechSummaryFactory.createList(7),
            dislikedTechs: TechSummaryFactory.createList(3),
            workplacePreferences: WorkplacePreferencesFactory.create(),
            profilePreferences: ProfilePreferencesFactory.create(),
            cvFile: MediaFactory.create(),
            avatar: MediaFactory.create(),
            availabilityStatus: 'ACTIVE',
            contractTypes: ['EMPLOYED', 'SELF_EMPLOYED'],
            desiredJobDescription: 'Desired job description',
            currentSalary: 50000,
            desiredSalary: SalaryFactory.create(),
            desiredSalaryDescription: 'Desired salary description',
            isNewsletterActive: false,
            preferredLanguage: 'ES',
            hasOnboardingComplete: true,
            isInterestedOnWorkAtManfred: false,
            isLegacy: false,
            tags: TagSummaryFactory.createList(2),
            offers: {
                applications: [1],
                applicationAttempt: {
                    offerId: 1,
                    position: 'backend developer',
                    slug: 'acme-company-developer',
                    companyName: 'acme'
                }
            }
        };
        return { ...defaultProps, ...props };
    }
    static createList(length = 1) {
        return Array.from({ length }).map(() => this.create());
    }
}
//# sourceMappingURL=manfredite.factory.js.map